/*
 * Constants..
 */

export const OVERLAY = "overlay--opened";
export const BACKDROP = "backdrop--opened";
export const BACKDROP_OVERLAY = "backdrop--overlay--opened";
